<template>
  <v-container fluid class="pl-7 pr-6">
    <v-card class="elevation-1 mt-5">
      <v-card-title>
        <v-row>
          <v-col cols="12" md="3">
            <!-- Date Range -->
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :return-value.sync="studyDates"
              :transition="false"
              min-width="290px"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-on:keydown.enter.tab="isExpanded = true"
                  :label="$t('Log Date')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="studyDates"
                :locale="$store.getters.locale"
                color="primary"
                scrollable
                no-title
                range
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="red lighten-2"
                  @click="
                    $refs.dateMenu.save([]);
                    preset = '';
                  "
                  >{{ $t("clear") }}</v-btn
                >
                <v-btn text color="primary" @click="dateMenu = false">{{
                  $t("cancel")
                }}</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="saveDates($refs.dateMenu)"
                  >{{ $t("accept") }}</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              clearable
              v-model="action"
              :items="actionItems"
              :label="$t('Action')"
              v-on:keyup.13="search"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="username"
              :label="$t('Username')"
              v-on:keyup.13="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="accessionNo"
              :label="$t('Accession Number')"
              v-on:keyup.13="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="patId"
              :label="$t('Patient Id')"
              v-on:keyup.13="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="patName"
              :label="$t('Patient Name')"
              v-on:keyup.13="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn
              class="ma-2"
              tile
              outlined
              color="primaryLigth"
              @click="search"
            >
              <v-icon left>mdi-magnify</v-icon>
              {{ $t("search") }}
            </v-btn>
          </v-col>
        </v-row>

        <!--

        -->
      </v-card-title>

      <v-simple-table fixed-header height="600px" :loading="loading" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">{{ $t("Timestamp") }}</th>
              <th class="text-left">{{ $t("Action") }}</th>
              <th class="text-left">{{ $t("User") }}</th>
              <th class="text-left">{{ $t("Accession Number") }}</th>
              <th class="text-left">{{ $t("Modality") }}</th>
              <th class="text-left">{{ $t("Patient Id") }}</th>
              <th class="text-left">{{ $t("Patient Name") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in log" :key="item.id">
              <td>{{ item.timestamp }}</td>
              <td>
                <v-chip :color="chipProps(item.action).color" small dark>
                  {{ chipProps(item.action).label }}
                </v-chip>
              </td>
              <td>{{ item.user.username }}</td>
              <td>{{ item.data.accessionNo }}</td>
              <td>{{ item.data.modality }}</td>
              <td>{{ item.data.patId }}</td>
              <td>{{ item.data.patName.replace("^", " ").trim() }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import i18n from "../i18n";
import EventBus from "../event-bus";

export default {
  name: "Auditory",
  components: {},
  data() {
    return {
      loading: true,
      log: [],
      dateMenu: false,
      studyDates: [],
      username: null,
      accessionNo: null,
      patId: null,
      patName: null,
      action: null,
      actionItems: [],
    };
  },
  computed: {
    dateRangeText() {
      this.flipDates();

      // format date display
      let fmtDate0 = this.formatDate(this.studyDates[0]);
      let fmtDate1 = this.formatDate(this.studyDates[1]);

      if (fmtDate0 != null) {
        if (fmtDate1 == null) {
          return fmtDate0 + "~" + fmtDate0;
        } else {
          return fmtDate0 + "~" + fmtDate1;
        }
      } else {
        return "";
      }
    },
  },
  created() {
    this.search();
    this.loadActionItems();
  },
  methods: {
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    search() {
      let url = "";

      if (this.studyDates.length) {
        url = url + "&start_datetime=" + this.studyDates[0] + "T00:00";
        url = url + "&end_datetime=" + this.studyDates[1] + "T23:59";
      }
      if (this.action) url = url + "&action=" + this.action;
      if (this.username) url = url + "&user.username=" + this.username;
      if (this.accessionNo) url = url + "&data.accession_no=" + this.accessionNo;
      if (this.patId) url = url + "&data.pat_id=" + this.patId;
      if (this.patName) url = url + "&data.pat_name=" + this.patName;

      url = url.substring(1);
      
      axios.get("/api/v1/auditory?" + url).then((response) => {
        this.loading = false;
        if (
          !response.data ||
          !response.data.status ||
          !(response.data.status == "done")
        ) {
          this.sendError(response.data.error);
        } else {
          this.log = response.data.log;
        }
      });
    },
    flipDates() {
      let date0 = new Date(this.studyDates[0]);
      let date1 = new Date(this.studyDates[1]);

      if (date0 > date1) {
        let tmp = this.studyDates[0];
        this.studyDates[0] = this.studyDates[1];
        this.studyDates[1] = tmp;
      }
    },
    saveDates(dateMenu) {
      if (this.studyDates.length == 1) {
        this.studyDates[1] = this.studyDates[0];
      }

      dateMenu.save(this.studyDates);
    },
    formatDate(date) {
      if (!date) return null;
      let [year, month, day] = date.split("-");
      year = year.slice(-2);
      return `${day}/${month}/${year}`;
    },
    loadActionItems() {
      let actions = [
        "DELETE_PATIENT",
        "DELETE_STUDY",
        "DELETE_SERIES",
        "UPDATE_PATIENT",
        "UPDATE_STUDY",
        "UPDATE_SERIES",
        "CLONE_STUDY",
      ];
      actions.forEach((element) => {
        this.actionItems.push({
          text: i18n.t(element.replace("_", " ")),
          value: element,
        });
      });
    },
    chipProps(src) {
      switch (src) {
        case "DELETE_PATIENT":
          return {
            label: i18n.t("DELETE PATIENT"),
            color: "red",
          };
        case "DELETE_STUDY":
          return {
            label: i18n.t("DELETE STUDY"),
            color: "red",
          };
        case "DELETE_SERIES":
          return {
            label: i18n.t("DELETE SERIES"),
            color: "red",
          };
        case "UPDATE_PATIENT":
          return {
            label: i18n.t("UPDATE PATIENT"),
            color: "orange",
          };
        case "UPDATE_STUDY":
          return {
            label: i18n.t("UPDATE STUDY"),
            color: "orange",
          };
        case "UPDATE_SERIES":
          return {
            label: i18n.t("UPDATE SERIES"),
            color: "orange",
          };
        case "CLONE_STUDY":
          return {
            label: i18n.t("CLONE STUDY"),
            color: "green",
          };
        default:
          return {
            label: i18n.t("UNKNOWN"),
            color: "gray",
          };
      }
    },
    updateTable() {},
  },
};
</script>

<style scoped>
</style>